import { ok, run } from "@maker/result";

function getParserByMime(mime?: string | null) {
	if (mime === "text/plain") {
		return "text";
	}

	if (
		mime?.startsWith("image/") ||
		mime?.startsWith("video/") ||
		mime === "application/pdf"
	) {
		return "blob";
	}

	return "json";
}

function parseRequestProperties(request: Request) {
	return {
		url: request.url,
		method: request.method,
		headers: Object.fromEntries(request.headers.entries()),
	};
}

function parseResponseProperties(response: Response) {
	return {
		status: response.status,
		statusText: response.statusText,
		url: response.url,
		type: response.type,
		redirected: response.redirected,
		ok: response.ok,
		headers: Object.fromEntries(response.headers.entries()),
	};
}

async function parsePayload(payload: Request | Response) {
	return await run(async () => {
		const parser = getParserByMime(payload.headers.get("content-type"));

		if (parser === "text") {
			return ok(await payload.text());
		}

		if (parser === "blob") {
			return ok(await payload.blob());
		}

		return ok(await payload.json());
	});
}

export {
	getParserByMime,
	parseRequestProperties,
	parseResponseProperties,
	parsePayload,
};
